import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  InputAdornment,
  Button,
  Box,
  Tabs,
  Tab,
  Popover,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  CircularProgress,
} from "@mui/material";

import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  addReport,
  updateReport,
  deleteRecruitmentReport,
  reviewReport,
} from "../../../store/recruitment/actions";

import ErrorMessage from "../../common/components/ErrorMessage";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import RecruitmentReportAdvert from "./RecruitmentReportAdvert";
import { showError, showSuccess } from "../../toastify";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { a11yProps } from "../../common/components/TabPanel";
import ViewReportLogs from "./ViewReportLogs";
import axios from "axios";
import TextEditorComponent from "../../common/components/TextEditorComponent";

const RecruitmentReportModal = (props) => {
  const {
    loading,
    showAddRecruitmentReportForm,
    setShowRecruitmentReportForm,
    recruitmentReport,
    addReport,
    updateReport,
    deleteRecruitmentReport,
    recruitmentReportAdverts,
    reviewReport,
    reportedCandidatesPassedExam,
    section,
    onRefreshReports,
  } = props;
  const { hasPermissions } = useRequiredAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [showDeleteReportDialog, setShowDeleteReportDialog] = useState(false);
  const [newStatusId, setNewStatusId] = useState(0);
  const [showConformReport, setShowConformReport] = useState(false);
  const [reason, setReason] = useState("");
  const [hasChanges, setHasChanges] = useState(false);
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const hasUnconfirmedPassedExamCandidates = async () => {
    const advertisementIds = recruitmentReportAdverts
      .map((advert) => +(advert?.advertismentId || advert?.advertisementId || 0))
      .filter(Boolean);

    if (!advertisementIds.length) {
      return false;
    }

    const responses = await Promise.all(
      advertisementIds.map((advertisementId) =>
        axios.get(
          `/api/recruitment/reports/candidates-passed-exam/${advertisementId}`
        )
      )
    );

    return responses.some(({ data }) =>
      Array.isArray(data)
        ? data.some(
            (application) => +application?.reportApplicationStatusId === 0
          )
        : false
    );
  };

  const onClose = () => {
    if (hasChanges && typeof onRefreshReports === "function") {
      onRefreshReports();
    }
    dispatch({
      type: "SET_REPORT",
      data: null,
    });
    setHasChanges(false);
    setShowDeleteReportDialog(false);
    setShowRecruitmentReportForm(false);
  };
  // console.log(reportedCandidatesPassedExam);
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showAddRecruitmentReportForm}
        fullWidth
        maxWidth={"lg"}
      >
        <DialogTitle className="text-primary">
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            <span className="text-dark">
              {recruitmentReport ? (
                <>
                  <div className="row">
                    <div className="col-12">
                      <span>{recruitmentReport?.entityName}</span> /{" "}
                      <span
                        className={`font-weight-bold text-uppercase text-${
                          [5, 6].includes(+recruitmentReport.statusId)
                            ? "danger"
                            : [1, 2, 3].includes(+recruitmentReport.statusId)
                            ? "primary"
                            : [7].includes(+recruitmentReport.statusId)
                            ? "warning"
                            : "success"
                        }`}
                      >
                        {recruitmentReport.statusName}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <>New Report</>
              )}
            </span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
          <div className="mt-2">
            {recruitmentReport && (
              <Box sx={{ width: "100%", mt: 0 }}>
                <Tabs
                  className="mt-2 justify-content-end"
                  value={tabValue}
                  onChange={handleChange}
                  aria-label="tabs"
                  allowScrollButtonsMobile
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab
                    className="text-capitalize"
                    label="Details"
                    {...a11yProps(0)}
                  />

                  <Tab
                    className="text-capitalize"
                    label="Approver logs "
                    {...a11yProps(1)}
                  />
                </Tabs>
              </Box>
            )}
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div style={{ minHeight: "700px" }}>
            {tabValue === 0 && (
              <ManageReport
                setShowDeleteReportDialog={setShowDeleteReportDialog}
                loading={loading}
                addReport={addReport}
                updateReport={updateReport}
                recruitmentReport={recruitmentReport}
                recruitmentReportAdverts={recruitmentReportAdverts}
                onReportChanged={() => setHasChanges(true)}
              />
            )}
            {tabValue === 1 && recruitmentReport && (
              <>
                <ViewReportLogs reportId={recruitmentReport?.id} />
              </>
            )}

            {showDeleteReportDialog && recruitmentReport && (
              <ConfirmationDialog
                confirmationDialog={showDeleteReportDialog}
                message={`Are you sure you want to delete this draft report?`}
                setConfirmationDialog={setShowDeleteReportDialog}
                onYes={() => {
                  setHasChanges(true);
                  deleteRecruitmentReport(recruitmentReport?.id, onClose);
                }}
              />
            )}
          </div>
        </DialogContent>
        <DialogActions className="py-0 mx-0 d-flex justify-content-center">
          {recruitmentReport && ![7].includes(+recruitmentReport.statusId) && (
            <div className="d-flex flex-row justify-content-start mx-2 my-2 w-100 float-start">
              <div
                className="card rounded-3 card-border-left badge ap-badge-info w-100 py-3 px-2 border border-primary"
                style={{
                  backgroundColor: "#f5f6f7",
                }}
              >
                <div className="d-flex justify-content-between align-items-center flex-wrap w-100 ">
                  <div className="flex-grow-1 text-left">
                    <p className="small p-0 ms-2 mb-0 rounded-3 text-primary">
                      <AccessTimeIcon />
                      {section==='ASSIGNED'?<>
                        <strong className="px-2" style={{ fontStyle: "italic" }}>
                            Report assigned to the employee
                          </strong>
                      </>:<>
                      {[1].includes(+recruitmentReport.statusId) && (
                        <>
                          <strong className="px-2" style={{ fontStyle: "italic" }}>
                            Submitted by HR and waiting for CBM to complete the
                            review.
                          </strong>
                        </>
                      )}
                      {[2].includes(+recruitmentReport.statusId) && (
                        <>
                          <strong className="px-2" style={{ fontStyle: "italic" }}>
                            Reviewed by CBM and waiting for NPSC to complete the
                            review.
                          </strong>
                        </>
                      )}
                      {[3].includes(+recruitmentReport.statusId) && (
                        <>
                          <strong className="px-2" style={{ fontStyle: "italic" }}>
                            Confirmed by the NPSC and pending final
                            approval from NPSC Supervisor.
                          </strong>
                        </>
                      )}
                      {[10].includes(+recruitmentReport.statusId) && (
                        <>
                          <strong className="px-2" style={{ fontStyle: "italic" }}>
                            Verified by the NPSC Supervisor and pending final
                            approval from NPSC Approver.
                          </strong>
                        </>
                      )}
                      {[4].includes(+recruitmentReport.statusId) && (
                        <>
                          <strong className="px-2 text-success" style={{ fontStyle: "italic" }}>
                            Report Approved
                          </strong>
                        </>
                      )}
                       {[5,6].includes(+recruitmentReport.statusId) && (
                        <>
                          <strong className="px-2 text-danger" style={{ fontStyle: "italic" }}>
                            Report Rejected
                          </strong>
                        </>
                      )}
                      </>}
                      
                    </p>
                  </div>
                  <div className="text-right  mr-2">
                    {recruitmentReport &&
                      [1].includes(+recruitmentReport.statusId) &&
                      hasPermissions(["IS_CBM"]) && section!='ASSIGNED' && (
                        <>
                          <Button
                            variant="contained"
                            color="success"
                            startIcon={
                              <span className="material-icons mr-1">
                                done_all
                              </span>
                            }
                            className="mr-2"
                            onClick={() => {
                              setNewStatusId(2);
                              setShowConformReport(true);
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            endIcon={
                              <span className="material-icons mr-1">
                                cancel
                              </span>
                            }
                            onClick={() => {
                              setNewStatusId(5);
                              setShowConformReport(true);
                            }}
                          >
                            Reject
                          </Button>
                        </>
                      )}

                    {recruitmentReport &&
                      [2].includes(+recruitmentReport.statusId) &&
                      hasPermissions(["IS_NPSC"])
                      && !hasPermissions(["IS_NPSC_SUPERVISOR",'IS_NPSC_APPROVER']) 
                      && section!='ASSIGNED' && (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            disabled={isLoading}
                            startIcon={
                              <span className="material-icons mr-1">
                                done_all
                              </span>
                            }
                            className="mr-2"
                            onClick={async () => {
                              const advert = recruitmentReportAdverts.find(
                                ({ statusId }) => +statusId === 1
                              );
                              if (advert) {
                                showError(
                                  "Please approve all reported position(s) first."
                                );
                                return false;
                              }

                              try {
                                setIsLoading(true);
                                const hasUnconfirmedEmployees =
                                  await hasUnconfirmedPassedExamCandidates();

                                if (hasUnconfirmedEmployees) {
                                  showError(
                                    "Please confirm or reject all candidates in 'View Candidates Passed Exam' before confirming the whole report."
                                  );
                                  return false;
                                }
                              } catch (error) {
                                showError(error);
                                return false;
                              } finally {
                                setIsLoading(false);
                              }

                              setNewStatusId(3);
                              setShowConformReport(true);
                            }}
                          >
                            Confirm
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            endIcon={
                              <span className="material-icons mr-1">
                                cancel
                              </span>
                            }
                            onClick={() => {
                              setNewStatusId(6);
                              setShowConformReport(true);
                            }}
                          >
                            Reject
                          </Button>
                        </>
                      )}

{recruitmentReport &&
                      [3].includes(+recruitmentReport.statusId) &&
                      hasPermissions(["IS_NPSC_SUPERVISOR"]) && section!='ASSIGNED' && (
                        <>
                          <Button
                            variant="contained"
                            color="success"
                            startIcon={
                              <span className="material-icons mr-1">
                                done_all
                              </span>
                            }
                            className="mr-2"
                            onClick={() => {
                              const advert = recruitmentReportAdverts.find(
                                ({ statusId }) => +statusId === 1
                              );
                              if (advert) {
                                showError(
                                  "Please approve all reported position(s) first."
                                );
                                return false;
                              }
                              setNewStatusId(10);
                              setShowConformReport(true);
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            endIcon={
                              <span className="material-icons mr-1">
                                cancel
                              </span>
                            }
                            onClick={() => {
                              setNewStatusId(6);
                              setShowConformReport(true);
                            }}
                          >
                            Reject
                          </Button>
                        </>
                      )}

                    {recruitmentReport &&
                      [10].includes(+recruitmentReport.statusId) &&
                      hasPermissions(["IS_NPSC_APPROVER"]) && section!='ASSIGNED' && (
                        <>
                          <Button
                            variant="contained"
                            color="success"
                            startIcon={
                              <span className="material-icons mr-1">
                                done_all
                              </span>
                            }
                            className="mr-2"
                            onClick={() => {
                              const advert = recruitmentReportAdverts.find(
                                ({ statusId }) => +statusId === 1
                              );
                              if (advert) {
                                showError(
                                  "Please approve all reported position(s) first."
                                );
                                return false;
                              }
                              setNewStatusId(4);
                              setShowConformReport(true);
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            endIcon={
                              <span className="material-icons mr-1">
                                cancel
                              </span>
                            }
                            onClick={() => {
                              setNewStatusId(6);
                              setShowConformReport(true);
                            }}
                          >
                            Reject
                          </Button>
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {showConformReport && (
            <ConfirmationDialog
              confirmationDialog={setShowConformReport}
              disabled={!reason}
              size="lg"
              message={
                <>
                  <div className="my-2 py-2 px-3">
                    <TextField
                      fullWidth
                      size="small"
                      multiline
                      rows={6}
                      name="reason"
                      label={`Give the reason that led to the ${
                        [5, 6].includes(+newStatusId)
                          ? "rejection"
                          : "confirmation"
                      } ..`}
                      variant="outlined"
                      placeholder={`Give the reason that led to the ${
                        [5, 6].includes(+newStatusId)
                          ? "rejection"
                          : "confirmation"
                      } ..`}
                      value={reason}
                      style={{ width: "600px" }}
                      onChange={(e) => {
                        setReason(e.target.value || "");
                      }}
                    />
                  </div>
                </>
              }
              setConfirmationDialog={setShowConformReport}
              onYes={() => {
                setHasChanges(true);
                reviewReport(
                  {
                    statusId: newStatusId,
                    reportId: recruitmentReport?.id,
                    reason,
                  },
                  onClose
                );
              }}
            />
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({
  loading,
  user,
  recruitmentReport,
  recruitmentReportAdverts,
  reportedCandidatesPassedExam,
}) => {
  return {
    loading,
    user,
    recruitmentReport,
    recruitmentReportAdverts,
    reportedCandidatesPassedExam,
  };
};
export default connect(mapStateToProps, {
  addReport,
  updateReport,
  deleteRecruitmentReport,
  reviewReport,
})(RecruitmentReportModal);

const ManageReport = (props) => {
  const {
    loading,
    recruitmentReport,
    addReport,
    updateReport,
    setShowDeleteReportDialog,
    recruitmentReportAdverts,
    onReportChanged,
  } = props;
  const { hasPermissions } = useRequiredAuth();
  const [showSubmitReportDialog, setShowSubmitReportDialog] = useState(false);
  const [formData, setFormData] = useState({
    title: recruitmentReport?.title || "",
    description: recruitmentReport?.description || "",
  });
  const [assignAnchorEl, setAssignAnchorEl] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [employeeSearchTerm, setEmployeeSearchTerm] = useState("");
  const [assignRemarks, setAssignRemarks] = useState("");
  const [isEmployeesLoading, setIsEmployeesLoading] = useState(false);
  const [assigningEmployeeId, setAssigningEmployeeId] = useState(null);
  const [selectedEmployeeForAssign, setSelectedEmployeeForAssign] = useState(null);
  const [showAssignConfirmDialog, setShowAssignConfirmDialog] = useState(false);

  const [errors, setErrors] = useState({
    titleHasError: false,
    descriptionHasError: false,
    hasError: false,
  });

  const formValidator = () => {
    const error = {
      titleHasError: false,
      descriptionHasError: false,
      hasError: false,
    };

    if (!formData.title) {
      error.titleHasError = true;
      error.hasError = true;
    }
    if (!formData.description) {
      error.descriptionHasError = true;
      error.hasError = true;
    }
    setErrors(error);

    if (error.hasError) {
      // showError("Please fill out all required fields");
      return true;
    }
    return false;
  };

  const onSave = () => {
    if (!formValidator()) {
      if (typeof onReportChanged === "function") {
        onReportChanged();
      }
      addReport(formData);
    }
  };
  const onUpdate = () => {
    if (recruitmentReportAdverts.length <= 0) {
      showError("Please assign advertisement(s) on this report");
      return false;
    }
    if (!formValidator()) {
      if (typeof onReportChanged === "function") {
        onReportChanged();
      }
      updateReport(recruitmentReport?.id, formData, setShowSubmitReportDialog);
    }
  };

  const handleOpenAssignPopover = async (event) => {
    setAssignAnchorEl(event.currentTarget);
    if (!employees.length) {
      await fetchEmployees();
    }
  };

  const handleCloseAssignPopover = () => {
    setAssignAnchorEl(null);
    setEmployeeSearchTerm("");
    setAssignRemarks("");
    setSelectedEmployeeForAssign(null);
    setShowAssignConfirmDialog(false);
  };

  const handleOpenAssignConfirmDialog = (employee) => {
    setSelectedEmployeeForAssign(employee);
    setAssignRemarks("");
    setShowAssignConfirmDialog(true);
  };

  const handleCloseAssignConfirmDialog = () => {
    setShowAssignConfirmDialog(false);
    setSelectedEmployeeForAssign(null);
    setAssignRemarks("");
  };

  const fetchEmployees = async () => {
    try {
      setIsEmployeesLoading(true);
      const { data } = await axios.get(
        "/api/recruitment/npsc-employees-with-roles/"+
        recruitmentReport?.id
      );
      setEmployees(Array.isArray(data) ? data : []);
    } catch (error) {
      showError(error);
    } finally {
      setIsEmployeesLoading(false);
    }
  };

  const onAssignEmployee = async (employee) => {
    if (!recruitmentReport?.id) {
      showError("Please save the report before assigning an employee.");
      return;
    }
    try {
      setAssigningEmployeeId(employee?.id);
      await axios.post("/api/recruitment/reports/assign", {
        reportId: recruitmentReport?.id,
        employeeId: employee?.id,
        remarks: (assignRemarks || "").trim(),
        isUnassign: employee?.isUnassign,
      });
      employee.isUnassign = employee?.isUnassign===0?1:0;
      showSuccess(
        !employee?.isUnassign
          ? "Employee unassigned from report successfully."
          : "Employee assigned to report successfully."
      );
      if (typeof onReportChanged === "function") {
        onReportChanged();
      }
      setAssignRemarks("");
      setShowAssignConfirmDialog(false);
      setSelectedEmployeeForAssign(null);
    } catch (error) {
      showError(error);
    } finally {
      setAssigningEmployeeId(null);
    }
  };

  const filteredEmployees = employees.filter((employee) => {
    const term = (employeeSearchTerm || "").toLowerCase();
    if (!term) return true;
    const id = employee?.id ? String(employee.id) : "";
    const name = `${employee?.firstName || ""} ${employee?.lastName || ""}`.trim();
    const position = employee?.positionName || "";
    const unit = employee?.unitName || "";
    const role = employee?.roleName || "";
    return [id, name, position, unit, role].some((value) =>
      String(value).toLowerCase().includes(term)
    );
  });

  const assignPopoverOpen = Boolean(assignAnchorEl);
  const assignPopoverId = assignPopoverOpen ? "assign-user-popover" : undefined;

  return (
    <>
      <div className="row">
        <div className={"col-lg-12 mt-2"}>
          <div className="row">
            <div className="col-lg-12">
              <div className="m-2">
                <TextField
                  fullWidth
                  size="small"
                  name="title"
                  label="Report title"
                  type="text"
                  value={formData.title || ""}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start"></InputAdornment>
                    ),
                    readOnly:
                      recruitmentReport &&
                      ![7].includes(+recruitmentReport?.statusId),
                  }}
                  onChange={(e) => {
                    const title = e.target.value;
                    setFormData({
                      ...formData,
                      title,
                    });

                    setErrors({
                      ...errors,
                      titleHasError: false,
                    });
                  }}
                />

                <ErrorMessage
                  hasError={errors.titleHasError}
                  message="Title is required"
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="m-2">
                <TextEditorComponent
                  id="recruitment-report-description"
                  options={{
                    defaultValue: formData.description || "",
                    height: "260px",
                    readOnly:
                      recruitmentReport &&
                      ![7].includes(+recruitmentReport?.statusId),
                  }}
                  onEditorChange={(data) => {
                    if (
                      recruitmentReport &&
                      ![7].includes(+recruitmentReport?.statusId)
                    ) {
                      return;
                    }
                    setFormData({
                      ...formData,
                      description: data?.contents || "",
                    });

                    setErrors({
                      ...errors,
                      descriptionHasError: false,
                    });
                  }}
                />

                <ErrorMessage
                  hasError={errors.descriptionHasError}
                  message="Description is required"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {recruitmentReport && (
        <div className={"col-lg-12"}>
          <div className="d-flex justify-content-end mx-2 mb-2">
            {hasPermissions(["IS_NPSC_SUPERVISOR"]) && [2].includes(+recruitmentReport.statusId) && (
              <>
                <Button
                  variant="contained"
                  color="info"
                  aria-describedby={assignPopoverId}
                  onClick={handleOpenAssignPopover}
                  startIcon={<span className="material-icons mr-1">person_add</span>}
                >
                  Assign employee
                </Button>
              </>
            )}
           
          </div>
          <Popover
            id={assignPopoverId}
            open={assignPopoverOpen}
            anchorEl={assignAnchorEl}
            onClose={handleCloseAssignPopover}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Card sx={{ minWidth: 500, maxWidth: 700 }}>
              <CardHeader
                sx={true}
                title="Assign user to report"
                action={
                  <IconButton aria-label="close" onClick={handleCloseAssignPopover}>
                    <span className="material-icons">close</span>
                  </IconButton>
                }
                subheader="Select an employee and assign them to this report"
              />
              <Divider />
              <CardContent>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Search by name, ID, role, unit, position..."
                  value={employeeSearchTerm}
                  onChange={(e) => setEmployeeSearchTerm(e.target.value)}
                />
                <div className="mt-3" style={{ maxHeight: "320px", overflow: "auto" }}>
                  {isEmployeesLoading && (
                    <div className="d-flex justify-content-center py-3">
                      <CircularProgress size={24} />
                    </div>
                  )}
                  {!isEmployeesLoading && filteredEmployees.length === 0 && (
                    <div className="text-center text-muted py-3">
                      No employees found.
                    </div>
                  )}
                  {!isEmployeesLoading &&
                    filteredEmployees.map((employee) => (
                      <div
                        key={employee?.id}
                        className="d-flex justify-content-between align-items-start border rounded p-2 mb-2"
                      >
                        <div className="pr-2">
                          <div className="font-weight-bold">
                            {employee?.firstName} {employee?.lastName}
                          </div>
                          <div className="text-muted small">
                            ID: {employee?.id || "N/A"}
                          </div>
                          <div className="small">
                            {employee?.positionName || "N/A"} 
                          </div>
                          
                         <div className={`small ${employee?.isUnassign===0 ? "text-danger" : "text-success"}`}>{employee?.isUnassign===0 ? "Unassigned" : "Assigned"}</div>
                       
                        </div>
                        <div className="text-right">
                          <Button
                            variant="contained"
                            size="small"
                            color={employee?.isUnassign ? "error" : "success"}
                            disabled={assigningEmployeeId === employee?.id}
                            onClick={() => handleOpenAssignConfirmDialog(employee)}
                          >
                            {assigningEmployeeId === employee?.id ? "Assigning..." : employee?.isUnassign ? "Unassign" : "Assign"}
                          </Button>
                        </div>
                      </div>
                    ))}
                </div>
              </CardContent>
              <Divider />
              <CardActions className="py-2 px-3">
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleCloseAssignPopover}
                >
                  Close
                </Button>
              </CardActions>
            </Card>
          </Popover>
          <Dialog
            open={showAssignConfirmDialog}
            onClose={handleCloseAssignConfirmDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              {selectedEmployeeForAssign?.isUnassign
                ? "Confirm Unassign Employee"
                : "Confirm Assign Employee"}
            </DialogTitle>
            <DialogContent>
              <Typography className="mb-2">
                {selectedEmployeeForAssign?.isUnassign
                  ? "Add remarks and confirm to unassign this employee from the report."
                  : "Add remarks and confirm to assign this employee to the report."}
              </Typography>
              <TextField
                fullWidth
                multiline
                minRows={3}
                autoFocus
                size="small"
                label="Remarks"
                placeholder="Enter remarks"
                value={assignRemarks}
                onChange={(e) => setAssignRemarks(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCloseAssignConfirmDialog}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color={selectedEmployeeForAssign?.isUnassign ? "error" : "success"}
                disabled={
                  !selectedEmployeeForAssign ||
                  assigningEmployeeId === selectedEmployeeForAssign?.id
                }
                onClick={() => onAssignEmployee(selectedEmployeeForAssign)}
              >
                {assigningEmployeeId === selectedEmployeeForAssign?.id
                  ? "Processing..."
                  : selectedEmployeeForAssign?.isUnassign
                  ? "Confirm Unassign"
                  : "Confirm Assign"}
              </Button>
            </DialogActions>
          </Dialog>
          <RecruitmentReportAdvert />
        </div>
      )}
      <div className="d-flex justify-content-center py-1 mt-3">
        {recruitmentReport ? (
          <>
            {[7].includes(+recruitmentReport.statusId) && (
              <>
                <Button
                  className=" mr-2"
                  color="success"
                  variant="contained"
                  onClick={() => setShowSubmitReportDialog(true)}
                  type="button"
                  disabled={loading || !hasPermissions(["IS_CBM", "IS_HR"])}
                >
                  {loading ? "Wait..." : "Submit To CBM"}
                </Button>
                <Button
                  color="error"
                  variant="contained"
                  onClick={() => setShowDeleteReportDialog(true)}
                  type="button"
                  disabled={loading || !hasPermissions(["IS_CBM", "IS_HR"])}
                >
                  {loading ? "Wait..." : "Delete Report"}
                </Button>
              </>
            )}
          </>
        ) : (
          <>
            <Button
              className="btn-block"
              variant="contained"
              onClick={onSave}
              type="button"
              disabled={loading}
            >
              {loading ? "Wait..." : "Next"}
            </Button>
          </>
        )}

        {showSubmitReportDialog && recruitmentReport && (
          <ConfirmationDialog
            confirmationDialog={showSubmitReportDialog}
            message={`Are you sure you want to submit this final report?`}
            setConfirmationDialog={setShowSubmitReportDialog}
            onYes={() => {
              onUpdate();
            }}
          />
        )}
      </div>
    </>
  );
};
